// extracted by mini-css-extract-plugin
module.exports = {"Modal":"ws_a bag_bk bag_bl bag_bm bag_bo bag_bn bag_tk","Modal__backdrop":"ws_b ws_a bag_bk bag_bl bag_bm bag_bo bag_bn bag_tk bag_cz"};